// extracted by mini-css-extract-plugin
export default {"item":"MenuGroup_item__xb2hH","container":"MenuGroup_container__4ndme","selected":"MenuGroup_selected__EPTnI"};